import React, { FC } from 'react';
import { Box, Text, TextFieldSize } from '@bechtel/gds';
import { useField } from 'formik';
import { useLingui } from '@lingui/react';
import { CommentDescriptionStyled } from './styled';

interface CommentProps {
  name: string;
  placeholder?: string;
  isDisabled: boolean;
}
export const Comment: FC<CommentProps> = ({ name, placeholder, isDisabled }) => {
  const [field, meta] = useField(name);

  return (
    <Box flexDirection={{ sm: 'column' }} css={{ width: '100%' }} data-testid="hours-input">
      <CommentDescriptionStyled
        {...field}
        value={field.value ? field.value : ''}
        placeholder={placeholder}
        disabled={isDisabled}
        size={TextFieldSize.LARGE}
        rows="8"
        maxlength={2000}
      />
      {meta.touched && meta.error ? <ErrorField error={meta.error} /> : null}
    </Box>
  );
};

const ErrorField = ({ error }) => {
  const { i18n } = useLingui();
  return (
    <Box pt={{ sm: '200' }}>
      <Text color="bechtel.red">{i18n._(error)}</Text>
    </Box>
  );
};
